import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import {
    createDepartment,
    fetchAllDepartments,
    resetStatus,
} from "../../store/slices/departmentSlice";

function DepartmentCreatePopup({ show, onHide, onClose, onSuccess, onCreated }) {
    const dispatch = useDispatch();

    const { loading, errorMessage } = useSelector(
        (state) => state.department || {}
    );

    const [departmentName, setDepartmentName] = useState("");
    const [departmentDescription, setDepartmentDescription] = useState("");

    useEffect(() => {
        if (!show) return;
        setDepartmentName("");
        setDepartmentDescription("");
        dispatch(resetStatus());
    }, [show, dispatch]);

    const handleClose = () => {
        dispatch(resetStatus());
        onHide?.();
        onClose?.();
    };

    const handleCreate = async () => {
        const name = (departmentName || "").trim();
        const description = (departmentDescription || "").trim();
        if (!name) return;

        // Create department
        const resultAction = await dispatch(
            createDepartment({ name, description })
        );


        if (createDepartment.fulfilled.match(resultAction)) {
            const created = resultAction.payload;
            // Refresh list (departmentSlice)
            await dispatch(fetchAllDepartments());

            onSuccess?.({ id: created?.id, name: created?.name });
            onCreated?.({ id: created?.id, name: created?.name });
            dispatch(resetStatus());
            handleClose();
        }
    };

    return (
        <Modal show={!!show} onHide={handleClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add New Department</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="form_group">
                    <label>Department Name</label>
                    <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Enter department name"
                        value={departmentName}
                        onChange={(e) => setDepartmentName(e.target.value)}
                    />
                </div>

                <div className="form_group">
                    <label>Description</label>
                    <textarea
                        className="form-control pl_16"
                        placeholder="Enter department description"
                        value={departmentDescription}
                        rows={4}
                        onChange={(e) => setDepartmentDescription(e.target.value)}
                    />
                </div>

                {errorMessage ? (
                    <div className="mt_10 text-danger">{errorMessage}</div>
                ) : null}
            </Modal.Body>

            <Modal.Footer>
                <Button className="btn_outline_secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button className="btn_primary" onClick={handleCreate} disabled={loading}>
                    {loading ? "Creating..." : "Create"}
                </Button>
            </Modal.Footer>

        </Modal>
    );
}

export default DepartmentCreatePopup;

